<script>
import router from "../../router";
import Alert from "@/components/Alert";
export default {
  name: "ViewPurchaseOrder",
  components: {
    Alert
  },
  data() {
    return {
      decimal_separator: ".",
precision: 0,
      currency: "",
      order: {
        items: []
      }
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/inventory_count/detail/" + id
        })
        .then(res => {
          this.order = res;
        });
    },
    edit() {
      if (this.order.id) {
        router.push("/edit-inventory-count/" + this.order.id);
      }
    },
    count() {
      router.push("/count-stock/" + this.order.id);
    },
    gettoback() {
      router.push("/inventory-count");
    }
  },
  mounted() {
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }
    
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-8">
            <div class="card rounded-5 border">
              <div class="card-header bg-white border-bottom px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-4 col-md-12 col-12 align-self-center mb-md-0 mb-3">
                    <a href="javascript:void(0)" @click="gettoback()" class="text-primary">
                      <i class="mdi mdi-chevron-left"></i>
                      {{$lang.messages.inventory_count}}
                    </a>
                  </div>
                  <div
                    class="col-lg-8 col-md-12 col-12 text-right"
                    v-if="order.inventory_count_status != 'COMPLETED'"
                  >
                    <a
                      href="javascript:void(0)"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                      @click="count()"
                    >{{$lang.messages.count_stock}}</a>
                    <a
                      href="javascript:void(0)"
                      @click="edit()"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                    >{{$lang.messages.edit}}</a>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row mb-4">
                  <div class="col-lg-12">
                    <h1 class="mb-0">{{order.ic_number}}</h1>
                    <p
                      class="text-grey font-14"
                      v-if="order.inventory_count_status == 'PENDING'"
                    >{{$lang.messages.pending}}</p>
                    <p
                      class="text-grey font-14"
                      v-else-if="order.inventory_count_status == 'COMPLETED'"
                    >{{$lang.messages.completed}}</p>
                    <p
                      class="text-grey font-14"
                      v-else-if="order.inventory_count_status == 'In_PROGRESS'"
                    >{{$lang.messages.in_progress}}</p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-lg-6">
                    <table>
                      <tr>
                        <td class="pr-3 f-semi-bold">{{$lang.messages.date_created}}:</td>
                        <td>{{order.created_at | moment("MMM DD, YYYY") }}</td>
                      </tr>

                      <tr>
                        <td class="f-semi-bold pr-3">{{$lang.messages.ordered_by}}:</td>
                        <td>{{order.createdBy}}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-lg-6">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.store}}</h4>
                    <p>{{order.store_name}}</p>
                    <p />
                  </div>
                </div>

                <div class="row mb-4" v-if="order.note">
                  <div class="col-12 mt-4">
                    <p class="f-semi-bold mb-0">{{$lang.messages.notes}}:</p>
                    <p>{{order.note}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <h3>{{$lang.messages.items}}</h3>
                    <table class="table table-striped table-style-1 table-responsive">
                      <thead>
                        <tr>
                          <th scope="col">{{$lang.messages.item}}</th>
                          <th scope="col">{{$lang.messages.expected_stock}}</th>
                          <th scope="col">{{$lang.messages.counted}}</th>
                          <th scope="col">{{$lang.messages.difference}}</th>
                          <th scope="col">{{$lang.messages.cost_difference}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="obj in order.items" :key="obj.id">
                          <td>
                            {{obj.name}}
                            <br />
                            <span
                              class="font-14 text-grey"
                              v-if="obj.sku"
                            >{{$lang.messages.sku}} {{obj.sku}}</span>
                          </td>
                          <td>{{obj.expected_stock ? obj.expected_stock : 0}}</td>
                          <td>{{obj.counted_stock ? obj.counted_stock : "-" }}</td>
                          <td>{{obj.difference ? Math.abs(obj.difference) : "-" }}</td>
                          <td>
                            <vue-numeric
                              v-if="obj.difference_cost"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :value="Math.abs(obj.difference_cost)"
                              :currency="currency"
                              :read-only="true"
                            />
                            <span v-else>-</span>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="f-semi-bold text-right">{{$lang.messages.total}}</td>
                          <td
                            class="f-semi-bold"
                          >{{order.total_difference ? order.total_difference : "-" }}</td>
                          <td
                            class="f-semi-bold"
                          >
                            <vue-numeric
                              v-if="order.total_difference_cost"
                              v-bind:precision="precision"
                              :separator="decimal_separator"
                              :currency="currency"
                              :value="order.total_difference_cost"
                              :read-only="true"
                            />
                            <span v-else>-</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>